import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { environment } from "environments/environment";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import { URLMODELS } from "../../../RoutesApi";
import { catchError } from "rxjs/operators";
import { PaginatedTROResponse } from "app/models/PaginatedTROResponse";

declare var $: any;

@Injectable()
export class ApiService {
  private hostRio: string; //"http://localhost/rioapp/api/";
  private hostLaravel: string;
  private urlIndicadores: string;
  private urlVersionRioOld: string;
  //private baseHrefLink : string;
  private hostTestes: string;
  private hostLaravelApi: string;
  private baseurl: string;

  private httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  constructor(private http: HttpClient) {}

  //public listarProfile(){
  //   return this.http.get<Profile[]>(`${GET_ME}`);

  //}

  getHostRio() {
    return this.hostRio;
  }

  getHostLaravelApi() {
    return this.hostLaravelApi;
  }

  // getBaseHrefLink(){
  //     return this.baseHrefLink;
  // }

  get(url: string, parans: string, host: string): Observable<any> {
    var urlGet = host + url;
    if (parans) {
      urlGet = urlGet + "/" + parans;
    }
    return this.http.get(urlGet, this.httpOptions).catch(this.erroHandler);
  }

  getTRO(url: string, params: any, host: string): Observable<any> {
    const urlGet = host + url;
    return this.http
      .get(urlGet, { ...this.httpOptions, params })
      .pipe(catchError(this.erroHandler));
  }

  post(url: string, parans: any, host: string): Observable<any> {
    var nUrl = host + url;
    if (url.indexOf("http") > -1) {
      nUrl = url;
    }
    return this.http
      .post(nUrl, parans, this.httpOptions)
      .catch(this.erroHandler);
  }

  put(url: string, parans: any, host: string): Observable<any> {
    var nUrl = host + url;
    return this.http
      .put(nUrl, parans, this.httpOptions)
      .catch(this.erroHandler);
  }

  deleteSafe(url: string, parans: any, host: string): Observable<any> {
    var nUrl = host + url;
    return this.http
      .put(nUrl, parans, this.httpOptions)
      .catch(this.erroHandler);
  }

  deletar(url: string, parans: string, host: string) {
    var urlDelete = host + url;
    if (parans) {
      urlDelete = urlDelete + "/" + parans;
    }
    return this.http
      .delete(urlDelete, this.httpOptions)
      .catch(this.erroHandler);
  }

  erroHandler(error: HttpErrorResponse) {
    return Observable.throw(error || "Server error");
  }

  load() {
    var vm = this;
    this.http
      .get("./assets/json/urls.json", this.httpOptions)
      .catch(this.erroHandler)
      .subscribe(
        function (data) {
          //vm.baseHrefLink = data[environment.baseHrefLink];
          vm.hostLaravelApi = data[environment.hostLaravel];
        },
        function (error) {
          console.log("getUrls error: ", error);
        }
      );
  }

  postTRO<T>(url: string, body: any, host: string): Observable<T> {
    const nUrl = host + url;
    return this.http.post<T>(nUrl, body, this.httpOptions).pipe(
      catchError(this.erroHandler)
    );
  }

  // Método para buscar TROs paginados com filtros opcionais
  getPaginatedTROs(body: any, page: number): Observable<PaginatedTROResponse> {
    const url = `${URLS.TRO.POST_TROS_FILTRADOS}?page=${page}`;
    return this.postTRO<PaginatedTROResponse>(url, body, environment.urlLaravel);
  }

  getSearch(search?: string): Observable<any[]> {
    return this.http
      .get<any[]>(
        `http://10.7.53.166:8080/mapa2api/public/api/getSolicitacaoById/${search}`,
        this.httpOptions
      )
      .catch(this.erroHandler);
  }
}

export const URLS = URLMODELS;



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts